import React from 'react';
import LiveNowIcon from 'components_v2/common/InitNewscardComponents/LiveNowIcon';
import s from './NewStoryCard.scss';
import { CARD_9 } from './cards';

export default function IconWrapper({
  iconClass,
  sectionNameTop,
  inlineCard,
  cardType,
  videoTime,
  cmstype,
}) {
  const iconClass2 = cardType === CARD_9 ? s.vsIcon : '';
  if (!inlineCard) {
    return null;
  }
  if (!(iconClass || sectionNameTop || videoTime || cmstype === 'LIVEBLOG')) {
    return null;
  }
  return (
    <section
      className={`${s.catLabelWrap} ${sectionNameTop ? '' : s.onlyIcon}`}
    >
      {sectionNameTop && <div className={s.catLabelText}>{sectionNameTop}</div>}
      {iconClass && cmstype !== 'LIVEBLOG' && (
        <span className={`${s[iconClass]} ${iconClass2} ${s.smallIcon}`}>
          <i />
          {videoTime && <span> {videoTime} </span>}
        </span>
      )}

      {/* Live Indicator for card_8 */}
      {cmstype === 'LIVEBLOG' && (
        <div className={s.liveBlinker}>
          <LiveNowIcon text="Live" />
        </div>
      )}
    </section>
  );
}
